function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMission(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 3710 3710",
    style: {
      enableBackground: "new 0 0 3710 3710"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "Background"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "#FFFFFF"
    },
    width: 3710,
    height: 3710
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Illustration"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_1_",
    gradientUnits: "userSpaceOnUse",
    x1: 3571.2126,
    y1: 4081.4114,
    x2: 1079.7383,
    y2: 987.1564
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#DAE3FE"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#E9EFFD"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_1_)"
    },
    d: "M2885.792,2861.149c-57.228,60.247-111.377,99.1-154.159,129.797 c-502.893,360.831-1097.948,255.651-1224.414,229.964c-186.751-37.93-547.736-111.248-808.721-418.162 c-394.849-464.335-333.366-1195.882-27.094-1678.786c56.022-88.331,351.946-578.591,953.411-657.214 c364-47.581,788.307,48.385,1095.578,305.817C3365.384,1312.939,3319.467,2404.59,2885.792,2861.149z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#BDD0FB"
    },
    d: "M3079.537,760.028c-5.49-14.969-27.447-12.623-29.582,3.178 c-20.634,152.759-87.288,551.625-243.835,780.271c-254.896,372.288-380.184,936.362-148.361,1186.927 C2657.759,2730.404,3677.76,2391,3079.537,760.028z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.43,
      fill: "#FFFFFF"
    },
    d: "M3079.929,973.815c0.301,4.856,0.164,8.888,0.206,13.229l-0.154,12.803 l-0.591,25.575c-0.51,17.041-1.282,34.069-2.055,51.097c-1.667,34.048-3.758,68.073-6.161,102.079 c-4.931,68.002-11.703,135.862-19.494,203.605c-7.696,67.761-17.288,135.306-28.306,202.62 c-11.077,67.301-23.111,134.472-37.347,201.211c-28.208,133.508-63.703,265.61-108.39,394.673 c-23.018,64.282-47.728,127.998-76.082,190.143c-28.79,61.918-60.228,122.644-95.952,180.805 c-0.777,1.265-2.432,1.66-3.697,0.883c-1.233-0.757-1.64-2.35-0.94-3.602l0.019-0.032 c33.317-59.288,63.388-120.258,90.405-182.574c27.194-62.25,50.743-126.023,72.597-190.313 c21.825-64.322,41.055-129.512,58.803-195.089c17.724-65.601,32.725-131.902,47.348-198.269 c28.689-132.896,50.267-267.272,68.139-402.106c8.793-67.444,16.226-135.073,22.458-202.818 c3.17-33.868,6.029-67.767,8.467-101.698l3.258-50.916l1.368-25.464l0.542-12.725c0.11-4.171,0.299-8.653,0.245-12.306 l-0.009-0.603c-0.022-1.471,1.153-2.682,2.624-2.704C3078.658,971.295,3079.839,972.406,3079.929,973.815z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#91B3FA"
    },
    d: "M2413.708,476.07c-9.118-12.229-28.614-4.088-26.261,10.985 c22.751,145.717,70.438,529.679-10.749,782.066c-132.191,410.943-93.207,962.406,187.741,1128.946 C2564.44,2398.066,3407.243,1808.557,2413.708,476.07z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.43,
      fill: "#FFFFFF"
    },
    d: "M2472.433,671.997c1.605,4.38,2.578,8.11,3.803,12.081l3.355,11.783l6.442,23.613 c4.186,15.767,8.126,31.592,12.066,47.418c7.766,31.678,15.138,63.45,22.218,95.289 c14.041,63.706,26.349,127.784,37.695,192.034c11.438,64.239,21.072,128.799,29.333,193.537 c8.205,64.741,15.497,129.625,20.65,194.715c10.557,130.133,14.032,260.967,8.252,391.52 c-3.583,65.232-8.871,130.406-17.93,195.133c-9.526,64.638-21.803,128.903-38.72,191.983c-0.375,1.397-1.811,2.225-3.208,1.851 c-1.362-0.365-2.184-1.739-1.877-3.101l0.009-0.035c14.356-63.463,25.288-127.578,33.048-192.094 c7.945-64.503,12.134-129.408,14.627-194.324c2.46-64.938,2.31-129.963,0.692-194.939 c-1.644-64.992-5.982-129.883-10.671-194.732c-9.936-129.695-26.811-258.806-47.184-387.332 c-10.326-64.248-21.953-128.296-34.706-192.121c-6.325-31.924-12.944-63.793-19.958-95.575l-10.892-47.583l-5.686-23.726 l-2.97-11.818c-1.035-3.853-2.085-8.02-3.126-11.345l-0.176-0.562c-0.428-1.368,0.333-2.825,1.701-3.253 C2470.546,669.997,2471.958,670.707,2472.433,671.997z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000103228813769185018960000015979245085210422185_",
    gradientUnits: "userSpaceOnUse",
    x1: 3997.0491,
    y1: 2030.1428,
    x2: -1343.6082,
    y2: 1602.8918
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#4F52FF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#4042E2"
    }
  })), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "url(#SVGID_00000103228813769185018960000015979245085210422185_)"
    },
    cx: 1569.263,
    cy: 1835.921,
    r: 1114.898
  }), /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.7071 -0.7071 0.7071 0.7071 -816.6905 1700.1686)",
    style: {
      fill: "#FFFFFF"
    },
    cx: 1643.94,
    cy: 1835.917,
    rx: 1114.898,
    ry: 1114.898
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000009568489746644146670000013201411374027915199_",
    gradientUnits: "userSpaceOnUse",
    x1: 3873.1409,
    y1: 724.5464,
    x2: -4739.5,
    y2: 5018.3882
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#4F52FF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#4042E2"
    }
  })), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "url(#SVGID_00000009568489746644146670000013201411374027915199_)"
    },
    cx: 1643.94,
    cy: 1835.917,
    r: 951.523
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M1643.938,2835.1c-550.947,0-999.179-448.228-999.179-999.183s448.232-999.183,999.179-999.183 s999.179,448.228,999.179,999.183S2194.885,2835.1,1643.938,2835.1z M1643.938,884.394 c-524.67,0-951.518,426.847-951.518,951.522c0,524.676,426.848,951.522,951.518,951.522 c524.671,0,951.518-426.847,951.518-951.522C2595.456,1311.241,2168.61,884.394,1643.938,884.394z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000052099249697206831810000008390019978948116371_",
    gradientUnits: "userSpaceOnUse",
    x1: 4760.8979,
    y1: -319.1495,
    x2: -2640.9807,
    y2: 4798.5127
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#4F52FF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#4042E2"
    }
  })), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "url(#SVGID_00000052099249697206831810000008390019978948116371_)"
    },
    cx: 1643.94,
    cy: 1835.917,
    r: 580.094
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M1643.938,2463.673c-346.143,0-627.751-281.613-627.751-627.756s281.608-627.747,627.751-627.747 c346.144,0,627.752,281.604,627.752,627.747S1990.082,2463.673,1643.938,2463.673z M1643.938,1303.484 c-293.586,0-532.436,238.847-532.436,532.432s238.85,532.441,532.436,532.441c293.587,0,532.437-238.855,532.437-532.441 S1937.525,1303.484,1643.938,1303.484z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000165916797339570864330000005363177418498135173_",
    gradientUnits: "userSpaceOnUse",
    x1: 3185.5259,
    y1: -1454.2249,
    x2: 1163.5225,
    y2: 2861.2507
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FF928E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FE7062"
    }
  })), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "url(#SVGID_00000165916797339570864330000005363177418498135173_)"
    },
    cx: 1643.94,
    cy: 1835.917,
    r: 224.745
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M1643.938,2108.323c-150.203,0-272.402-122.198-272.402-272.406s122.199-272.406,272.402-272.406 c150.203,0,272.406,122.198,272.406,272.406S1794.142,2108.323,1643.938,2108.323z M1643.938,1658.825 c-97.646,0-177.087,79.441-177.087,177.091s79.441,177.091,177.087,177.091c97.647,0,177.091-79.441,177.091-177.091 S1741.585,1658.825,1643.938,1658.825z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000036955804811593038890000003591826120180003476_",
    gradientUnits: "userSpaceOnUse",
    x1: 426.3276,
    y1: 9172.1924,
    x2: 327.6005,
    y2: 10231.2725,
    gradientTransform: "matrix(0.2244 -0.9745 0.9745 0.2244 -6015.6138 520.1205)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#4F52FF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#4042E2"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000036955804811593038890000003591826120180003476_)"
    },
    d: "M3196.649,2171.028l47.61,96.083 l-201.883-46.48c-66.145-15.229-121.972-59.324-152.107-120.143l0,0L3196.649,2171.028z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000013167579151362673240000004311788401271541431_",
    gradientUnits: "userSpaceOnUse",
    x1: 172.4629,
    y1: 9172.6807,
    x2: 73.7368,
    y2: 10231.75,
    gradientTransform: "matrix(-0.2244 0.9745 0.9745 0.2244 -5860.6768 -154.9203)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#4F52FF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#4042E2"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000013167579151362673240000004311788401271541431_)"
    },
    d: "M3203.295,2142.161l84.832-65.591 l-201.882-46.48c-66.145-15.229-135.633,0.014-189.33,41.532l0,0L3203.295,2142.161z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000006709805061129638080000011397040525990112181_",
    gradientUnits: "userSpaceOnUse",
    x1: 736.0898,
    y1: 7619.0273,
    x2: 452.0268,
    y2: 8773.0293,
    gradientTransform: "matrix(0.2244 -0.9745 0.9745 0.2244 -6015.6138 520.1205)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#09005D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#1A0F91"
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "url(#SVGID_00000006709805061129638080000011397040525990112181_)"
    },
    points: "3207.861,2138.178  3199.894,2172.782 1889.57,1871.102 1897.536,1836.498  "
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000124149124941875893890000010472855720432923554_",
    gradientUnits: "userSpaceOnUse",
    x1: 493.8541,
    y1: 7861.5898,
    x2: 407.053,
    y2: 8792.7354,
    gradientTransform: "matrix(0.2244 -0.9745 0.9745 0.2244 -6015.6138 520.1205)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#09005D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#1A0F91"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000124149124941875893890000010472855720432923554_)"
    },
    d: "M1958.327,1819.439 c19.852,4.57-1.695,98.158-21.547,93.587l-301.453-108.485c-11.137-4.008-7.312-20.625,4.458-19.359L1958.327,1819.439z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000075864862471496163090000002551004436419175583_",
    gradientUnits: "userSpaceOnUse",
    x1: 2140.7483,
    y1: 2396.7139,
    x2: 2284.8201,
    y2: 2396.7139,
    gradientTransform: "matrix(-0.9994 0.0349 0.0349 0.9994 4350.1494 734.0373)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#09005D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#1A0F91"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000075864862471496163090000002551004436419175583_)"
    },
    d: "M2278.167,3169.509 c0,0,16.092,23.195,16.9,55.775c0.191,7.673-6.018,14.008-13.69,14.276l-123.865,4.32c-5.799,0.202-8.414-7.169-3.784-10.667 c22.865-17.277,67.861-49.631,100.759-62.877L2278.167,3169.509z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000168075186906100344230000013769015837406717092_",
    gradientUnits: "userSpaceOnUse",
    x1: 2126.9277,
    y1: 1776.8901,
    x2: 2163.9634,
    y2: 1776.8901,
    gradientTransform: "matrix(-0.9907 0.1362 0.1362 0.9907 4148.8657 1097.9357)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FEBBBA"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FF928E"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000168075186906100344230000013769015837406717092_)"
    },
    d: "M2281.253,3129.964l-3.173,47.616 c-0.355,5.326-4.943,9.506-10.262,9.063c-3.234-0.269-7.12-1.102-11.414-3.031c-4.082-1.833-6.602-6.043-6.434-10.515 l2.155-57.455L2281.253,3129.964z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000013187335869755213930000016791686575171345844_",
    gradientUnits: "userSpaceOnUse",
    x1: -598.8804,
    y1: -2156.1299,
    x2: -454.8108,
    y2: -2156.1299,
    gradientTransform: "matrix(-0.1553 0.9879 0.9879 0.1553 5042.2178 3878.9236)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#09005D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#1A0F91"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000013187335869755213930000016791686575171345844_)"
    },
    d: "M2968.229,2961.763 c0,0,25.827-11.399,57.968-6.012c7.571,1.269,12.612,8.567,11.419,16.15l-19.26,122.434c-0.902,5.733-8.635,6.902-11.191,1.692 c-12.625-25.728-35.854-76.045-42.618-110.858L2968.229,2961.763z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000024691728766534144630000005591510064767908030_",
    gradientUnits: "userSpaceOnUse",
    x1: -1060.4637,
    y1: -2473.792,
    x2: -1023.4249,
    y2: -2473.792,
    gradientTransform: "matrix(-0.0542 0.9985 0.9985 0.0542 5360.7578 4145.1694)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FEBBBA"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FF928E"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000024691728766534144630000005591510064767908030_)"
    },
    d: "M2929.987,2951.231l46.149,12.15 c5.162,1.359,8.395,6.656,6.951,11.795c-0.878,3.124-2.433,6.781-5.142,10.632c-2.575,3.66-7.186,5.334-11.544,4.322 l-56.003-13.017L2929.987,2951.231z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000067196716531569933670000011317198326017869969_",
    gradientUnits: "userSpaceOnUse",
    x1: 2299.2639,
    y1: 2448.8579,
    x2: 2360.186,
    y2: 2461.2847,
    gradientTransform: "matrix(0.9932 0.1165 -0.1165 0.9932 243.8806 -741.6713)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FEBBBA"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FF928E"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000067196716531569933670000011317198326017869969_)"
    },
    d: "M2297.971,1987.885 c0,0-4.147-9.594-3.481-15.268c0.666-5.674,0.827-23.39-9.799-30.868c0,0-5.759,0.283-5.871,6.741 c-6.77-7.265-7.113-13.537-14.105-9.085c-6.993,4.452-33.312,20.417-20.168,30.947c13.144,10.53,33.8,30.568,33.8,30.568 L2297.971,1987.885z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000152973449985702849290000009442748466896719272_",
    gradientUnits: "userSpaceOnUse",
    x1: 2675.5417,
    y1: 2769.8689,
    x2: 2949.7517,
    y2: 3299.2466
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#09005D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#1A0F91"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000152973449985702849290000009442748466896719272_)"
    },
    d: "M2526.034,2753.917 c0,0,23.441,187.092,90.566,194.233c67.125,7.14,324.197,44.273,324.197,44.273l7.141-38.561c0,0-148.531-89.975-237.078-88.548 c-44.274-65.697-33.474-247.221-33.474-247.221L2526.034,2753.917z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000183929718363373009110000004853832034989465750_",
    gradientUnits: "userSpaceOnUse",
    x1: 1936.2156,
    y1: 2972.1636,
    x2: 2387.5881,
    y2: 2413.9785
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FF928E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FE7062"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000183929718363373009110000004853832034989465750_)"
    },
    d: "M2802.171,2100.729 c-7.905,208.586-117.323,227.015-117.323,227.015v266.783h-154.282c0,0-74.808-182.176-72.866-243.074 c-111.266-47.052-167.587-316.084-179.353-350.532c5.484-4.171,8.428-4.01,19.625-13.036 c151.663,241.371,188.664,278.473,188.664,278.473h85.691c164.66-14.786,205.167-171.311,205.167-171.311L2802.171,2100.729z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000168103492933150541440000018255133667058187399_",
    gradientUnits: "userSpaceOnUse",
    x1: 2291.5596,
    y1: 2843.7346,
    x2: 2617.8892,
    y2: 2910.2986
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#09005D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#1A0F91"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000168103492933150541440000018255133667058187399_)"
    },
    d: "M2680.031,2593.961 c0,0,12.263,130.719-245.229,232.597c-62.84,117.11-145.256,335.425-145.256,335.425h-54.271 c0,0,37.133-329.712,102.829-395.409c65.696-65.697,137.365-139.625,192.458-171.998 C2658.017,2581.246,2680.031,2593.961,2680.031,2593.961z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000047762709702328282460000007528300819451746749_",
    gradientUnits: "userSpaceOnUse",
    x1: 1990.0829,
    y1: 2225.0168,
    x2: 1721.344,
    y2: 2718.7981,
    gradientTransform: "matrix(-0.9937 -0.112 -0.112 0.9937 4681.1475 24.4975)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FEBBBA"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FF928E"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000047762709702328282460000007528300819451746749_)"
    },
    d: "M2570.249,2169.124l28.399,100.02 c0,0-48.529,26.083-84.411,19.034l-9.86-88.169L2570.249,2169.124z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000007430627728814656590000015927328908757798032_",
    gradientUnits: "userSpaceOnUse",
    x1: 1049.8236,
    y1: 5325.1733,
    x2: 931.0512,
    y2: 5482.2993,
    gradientTransform: "matrix(-0.7472 -0.6646 -0.6646 0.7472 6851.9165 -1168.7673)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FEBBBA"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FF928E"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000007430627728814656590000015927328908757798032_)"
    },
    d: "M2511.416,2096.486 c-1.041,1.171-39.666,97.227-39.666,97.227l55.315,20.888l50.135-85.603 C2577.201,2128.998,2528.838,2076.897,2511.416,2096.486z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000182504155940343514330000006203347691699929500_",
    gradientUnits: "userSpaceOnUse",
    x1: 959.1164,
    y1: 5363.0757,
    x2: 1100.9932,
    y2: 5363.0757,
    gradientTransform: "matrix(-0.7472 -0.6646 -0.6646 0.7472 6851.9165 -1168.7673)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#09005D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#1A0F91"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000182504155940343514330000006203347691699929500_)"
    },
    d: "M2554.213,2140.271l-22.862,47.13 c-0.294,0.604-0.656,1.152-1.102,1.655c-2.729,3.076-12.892,12.97-22.381,1.956c-8.611-9.996-16.617-18.989-24.681-21.366 c-3.619-1.068-7.452,0.782-8.859,4.285c-3.507,8.728-11.047,28.543-14.97,46.758c-0.796,3.697,1.404,7.366,5.016,8.483 c10.885,3.366,34.039,9.824,53.883,10.656c2.689,0.113,5.218-1.223,6.604-3.529c6.762-11.244,27.442-45.342,34.674-53.951 c6.788-8.082,20.987-6.233,26.893-5.031c1.937,0.394,3.931-0.02,5.554-1.148c5.735-3.987,16.986-14.547,4.589-30.106 c-2.594-3.255-1.984-7.968,1.351-10.463c6.636-4.966,14.182-14.249,5.584-27.786c-8.74-13.761-22.381-13.266-30.938-11.194 c-3.46,0.838-6.927-0.975-8.391-4.22c-0.833-1.847-2.479-3.361-5.62-3.443c-4.232-0.112-7.363-4.008-6.813-8.206 c1.056-8.065-0.686-18.601-14.213-24.545c-24.004-10.548-42.227,11.736-45.785,29.496 c-3.559,17.76,23.116,27.716,39.393,28.327c12.375,0.464,20.115,13.655,23.115,19.95 C2555.203,2135.972,2555.177,2138.283,2554.213,2140.271z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000174591418625539821240000015736085693684452532_",
    gradientUnits: "userSpaceOnUse",
    x1: 875.8669,
    y1: 5449.605,
    x2: 971.1337,
    y2: 5351.8638,
    gradientTransform: "matrix(-0.7472 -0.6646 -0.6646 0.7472 6851.9165 -1168.7673)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FEBBBA"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FF928E"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000174591418625539821240000015736085693684452532_)"
    },
    d: "M2551.039,2199.423 c0,0,7.528-30.679,20.651-30.745c13.124-0.064,24.529,12,9.683,28.023C2562.906,2216.632,2551.039,2199.423,2551.039,2199.423 z"
  }))), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000011024237901887844110000001870062507744985495_",
    gradientUnits: "userSpaceOnUse",
    x1: 2774.4014,
    y1: 2067.2852,
    x2: 2810.6677,
    y2: 2074.6826
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FEBBBA"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FF928E"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000011024237901887844110000001870062507744985495_)"
    },
    d: "M2807.338,2045.699 c0,0-33.324-14.758-29.04,9.998c4.285,24.755-4.665,42.846,14.33,44.75C2811.623,2102.351,2813.786,2062.807,2807.338,2045.699z "
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.3
    }
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#91B3FA"
    },
    d: "M834.386,953.729c-5.363,0.273-10.177-3.545-11.024-8.967 c-1.857-11.857-3.225-23.971-4.069-36.004c-0.41-5.855,4.001-10.933,9.855-11.344c0.07-0.004,0.139-0.007,0.207-0.011 c5.765-0.294,10.73,4.083,11.135,9.867c0.8,11.433,2.102,22.939,3.864,34.203c0.908,5.796-3.055,11.234-8.854,12.141 C835.127,953.675,834.755,953.71,834.386,953.729z M830.36,861.257c-0.415,0.021-0.837,0.018-1.262-0.01 c-5.854-0.392-10.285-5.456-9.893-11.31c0.806-12.026,2.134-24.136,3.948-35.993c0.887-5.801,6.284-9.77,12.109-8.899 c5.801,0.889,9.782,6.313,8.895,12.109c-1.724,11.271-2.984,22.775-3.749,34.204 C840.045,856.787,835.663,860.987,830.36,861.257z M846.794,770.199c-1.181,0.06-2.393-0.078-3.591-0.436 c-5.619-1.688-8.811-7.609-7.126-13.229c3.452-11.521,7.451-23.036,11.884-34.224c2.165-5.454,8.34-8.117,13.792-5.964 c5.454,2.162,8.125,8.338,5.964,13.792c-4.211,10.624-8.006,21.556-11.286,32.498 C855.105,767.058,851.155,769.977,846.794,770.199z M883.186,685.084c-1.952,0.099-3.955-0.339-5.78-1.376 c-5.101-2.898-6.886-9.386-3.988-14.486c5.95-10.464,12.421-20.796,19.236-30.709c3.326-4.828,9.937-6.054,14.775-2.735 c4.834,3.323,6.058,9.939,2.735,14.775c-6.473,9.414-12.621,19.227-18.271,29.172 C890.029,682.999,886.69,684.906,883.186,685.084z M937.642,610.223c-2.738,0.14-5.527-0.774-7.709-2.77 c-4.332-3.96-4.633-10.68-0.673-15.009c8.101-8.861,16.697-17.502,25.547-25.674c4.307-3.985,11.03-3.72,15.013,0.594 c3.98,4.31,3.714,11.031-0.596,15.015c-8.414,7.767-16.583,15.98-24.282,24.4C942.978,608.929,940.336,610.086,937.642,610.223 z M1007.298,549.277c-3.546,0.181-7.102-1.417-9.276-4.547c-3.348-4.82-2.156-11.439,2.662-14.788 c9.875-6.861,20.17-13.386,30.596-19.386c5.089-2.927,11.582-1.176,14.509,3.911c2.927,5.082,1.176,11.58-3.909,14.507 c-9.907,5.703-19.687,11.899-29.071,18.419C1011.12,548.567,1009.211,549.18,1007.298,549.277z M1394.828,504.202 c-1.469,0.075-2.975-0.156-4.432-0.73c-10.619-4.188-21.564-7.968-32.53-11.233c-5.623-1.675-8.825-7.591-7.15-13.212 c1.672-5.625,7.589-8.827,13.214-7.152c11.549,3.438,23.078,7.418,34.261,11.826c5.46,2.153,8.139,8.324,5.986,13.782 C1402.6,501.487,1398.861,503.996,1394.828,504.202z M1088.675,505.312c-4.402,0.224-8.656-2.326-10.395-6.643 c-2.193-5.444,0.442-11.633,5.884-13.826c11.155-4.495,22.642-8.559,34.141-12.079c5.617-1.691,11.553,1.435,13.271,7.049 c1.717,5.61-1.44,11.551-7.051,13.271c-10.921,3.341-21.828,7.2-32.421,11.468 C1090.978,505.003,1089.821,505.254,1088.675,505.312z M1305.448,480.174c-0.7,0.036-1.415,0.006-2.135-0.103 c-11.294-1.706-22.812-2.943-34.232-3.687c-5.856-0.383-10.294-5.439-9.913-11.293c0.383-5.854,5.433-10.32,11.293-9.913 c12.016,0.784,24.136,2.086,36.02,3.878c5.802,0.876,9.797,6.291,8.921,12.091 C1314.636,476.228,1310.389,479.922,1305.448,480.174z M1177.833,480.627c-5.355,0.273-10.164-3.534-11.021-8.946 c-0.919-5.796,3.035-11.237,8.83-12.16c11.866-1.88,23.973-3.274,35.984-4.136c0.074-0.008,0.151-0.012,0.226-0.016 c5.757-0.293,10.717,4.071,11.134,9.847c0.421,5.855-3.98,10.941-9.835,11.36c-11.409,0.822-22.908,2.148-34.182,3.936 C1178.589,480.568,1178.209,480.608,1177.833,480.627z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#91B3FA"
    },
    d: "M1461.471,537.736c-2.089,0.106-4.232-0.399-6.144-1.59c-4.65-2.896-9.439-5.74-14.232-8.463 c-5.103-2.894-6.894-9.381-3.998-14.482c2.894-5.105,9.383-6.902,14.484-3.996c5.043,2.86,10.078,5.853,14.973,8.899 c4.98,3.1,6.507,9.654,3.407,14.633C1468.051,535.809,1464.829,537.565,1461.471,537.736z"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.3
    }
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#91B3FA"
    },
    d: "M1647.798,802.698c-5.121,0.261-9.818-3.223-10.921-8.399 c-1.139-5.357-2.411-10.781-3.78-16.118c-1.457-5.685,1.969-11.474,7.652-12.931c5.708-1.463,11.474,1.971,12.932,7.652 c1.439,5.619,2.78,11.331,3.981,16.972c1.221,5.739-2.441,11.382-8.18,12.605 C1648.919,802.599,1648.356,802.67,1647.798,802.698z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#91B3FA"
    },
    d: "M1264.615,1302.418c-4.882,0.249-9.788,0.415-14.714,0.5 c-5.867,0.099-10.705-4.574-10.807-10.441c-0.101-5.867,4.6-10.728,10.439-10.809c11.37-0.197,22.706-0.854,33.821-1.969 c5.845-0.576,11.046,3.672,11.632,9.509c0.586,5.842-3.673,11.05-9.512,11.634 C1278.599,1301.535,1271.58,1302.063,1264.615,1302.418z M1193.881,1300.051c-0.593,0.03-1.198,0.011-1.809-0.062 c-11.771-1.399-23.615-3.314-35.199-5.691c-5.747-1.178-9.451-6.795-8.273-12.54c1.18-5.749,6.806-9.468,12.544-8.273 c11.003,2.257,22.253,4.073,33.439,5.406c5.826,0.692,9.987,5.978,9.295,11.802 C1203.257,1295.912,1198.957,1299.792,1193.881,1300.051z M1340.585,1291.42c-5.003,0.255-9.637-3.07-10.856-8.115 c-1.378-5.706,2.13-11.445,7.834-12.825c10.911-2.634,21.857-5.772,32.538-9.333c5.57-1.846,11.584,1.155,13.439,6.721 c1.854,5.569-1.155,11.586-6.722,13.441c-11.247,3.748-22.777,7.053-34.267,9.829 C1341.894,1291.295,1341.236,1291.387,1340.585,1291.42z M1105.149,1279.394c-1.347,0.069-2.728-0.123-4.078-0.599 c-11.166-3.948-22.298-8.422-33.085-13.295c-5.347-2.416-7.722-8.707-5.306-14.054c2.416-5.351,8.705-7.728,14.056-5.308 c10.243,4.626,20.813,8.875,31.417,12.624c5.533,1.953,8.431,8.027,6.475,13.558 C1113.151,1276.501,1109.32,1279.182,1105.149,1279.394z M1426.158,1260.381c-4.103,0.209-8.134-1.987-10.071-5.907 c-2.599-5.261-0.441-11.634,4.82-14.233c10.059-4.967,20.046-10.438,29.688-16.257c5.023-3.032,11.555-1.42,14.587,3.608 c3.03,5.023,1.416,11.551-3.607,14.582c-10.149,6.127-20.665,11.887-31.256,17.118 C1428.978,1259.954,1427.563,1260.309,1426.158,1260.381z M1502.849,1211.314c-3.28,0.167-6.593-1.185-8.815-3.935 c-3.686-4.566-2.974-11.256,1.593-14.941c8.755-7.07,17.315-14.592,25.44-22.353c4.237-4.06,10.961-3.908,15.021,0.34 c4.054,4.244,3.9,10.967-0.342,15.023c-8.551,8.169-17.558,16.083-26.772,23.522 C1507.161,1210.434,1505.013,1211.204,1502.849,1211.314z M1567.02,1146.696c-2.495,0.127-5.043-0.62-7.152-2.299 c-4.591-3.652-5.351-10.337-1.698-14.928c7.014-8.814,13.732-18.016,19.967-27.359c3.257-4.878,9.849-6.199,14.735-2.937 c4.879,3.259,6.195,9.853,2.937,14.736c-6.563,9.83-13.633,19.519-21.012,28.792 C1572.821,1145.183,1569.958,1146.546,1567.02,1146.696z M1615.567,1069.626c-1.729,0.088-3.501-0.245-5.169-1.054 c-5.279-2.561-7.482-8.915-4.92-14.194c4.915-10.128,9.45-20.578,13.483-31.064c2.106-5.476,8.261-8.208,13.728-6.106 c5.478,2.106,8.21,8.254,6.104,13.73c-4.247,11.046-9.024,22.052-14.197,32.713 C1622.841,1067.265,1619.312,1069.436,1615.567,1069.626z M1646.022,983.746c-0.972,0.049-1.967-0.037-2.962-0.269 c-5.713-1.334-9.264-7.049-7.929-12.761c2.553-10.935,4.674-22.121,6.301-33.258c0.849-5.807,6.261-9.819,12.049-8.975 c5.807,0.847,9.826,6.244,8.977,12.051c-1.713,11.722-3.945,23.501-6.635,35.012 C1654.721,980.265,1650.631,983.511,1646.022,983.746z M1656.859,893.334c-0.218,0.011-0.438,0.014-0.658,0.013 c-5.866-0.059-10.576-4.863-10.516-10.73c0.083-8.282-0.089-16.663-0.509-24.92c-0.152-2.988-0.34-5.971-0.555-8.939 c-0.425-5.854,3.974-10.944,9.826-11.367c5.917-0.547,10.941,3.972,11.367,9.822c0.228,3.126,0.423,6.257,0.583,9.403 c0.443,8.683,0.622,17.505,0.534,26.215C1666.876,888.477,1662.423,893.051,1656.859,893.334z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#91B3FA"
    },
    d: "M1022.932,1239.564c-2.11,0.107-4.27-0.41-6.191-1.617c-4.868-3.064-9.764-6.288-14.55-9.585 c-4.834-3.328-6.055-9.943-2.727-14.775c3.33-4.832,9.939-6.058,14.775-2.727c4.548,3.13,9.198,6.193,13.819,9.103 c4.965,3.121,6.459,9.681,3.334,14.649C1029.475,1237.656,1026.268,1239.394,1022.932,1239.564z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#91B3FA"
    },
    d: "M1030.978,1115.761c1.421,1.571,3.683,2.068,5.631,1.236l55.588-23.719 c23.209,16.061,49.146,28.538,77.059,36.569l16.809,58.012c0.589,2.035,2.405,3.471,4.521,3.578l72.403,3.627 c2.116,0.105,4.066-1.143,4.856-3.107l22.521-56.043c28.577-5.203,55.63-15.024,80.327-28.687l52.941,29.155 c1.856,1.022,4.155,0.754,5.726-0.667l53.761-48.633c1.572-1.422,2.068-3.684,1.236-5.631l-23.719-55.588 c16.061-23.208,28.537-49.147,36.568-77.06l58.013-16.809c2.035-0.589,3.471-2.404,3.577-4.521l3.626-72.404 c0.106-2.116-1.142-4.066-3.108-4.855l-56.043-22.521c-5.202-28.577-15.023-55.63-28.686-80.327l29.155-52.942 c1.021-1.855,0.753-4.155-0.667-5.726l-48.633-53.76c-1.421-1.572-3.683-2.068-5.631-1.236l-55.588,23.72 c-23.208-16.062-49.146-28.538-77.059-36.569l-16.809-58.013c-0.59-2.034-2.404-3.471-4.521-3.578l-72.404-3.625 c-2.116-0.107-4.066,1.142-4.856,3.108l-22.521,56.043c-28.577,5.201-55.63,15.024-80.328,28.687l-52.94-29.154 c-1.855-1.023-4.156-0.754-5.727,0.667l-53.76,48.633c-1.571,1.421-2.067,3.682-1.237,5.631l23.719,55.588 c-16.062,23.208-28.537,49.146-36.568,77.06l-58.013,16.809c-2.034,0.589-3.471,2.405-3.576,4.521l-3.626,72.402 c-0.106,2.116,1.142,4.066,3.107,4.857l56.043,22.521c5.202,28.576,15.024,55.629,28.686,80.327l-29.154,52.941 c-1.022,1.856-0.754,4.154,0.667,5.727L1030.978,1115.761z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#BDD0FB"
    },
    d: "M1246.37,948.132c-35.475,1.808-67.953-22.655-75.117-58.501 c-7.873-39.404,17.776-77.862,57.177-85.737c19.089-3.82,38.519,0.032,54.709,10.83 c16.194,10.798,27.214,27.257,31.026,46.345c7.874,39.405-17.776,77.862-57.176,85.737 C1253.436,947.514,1249.887,947.953,1246.37,948.132z M1239.984,819.536c-2.74,0.14-5.484,0.479-8.223,1.026 c-30.209,6.036-49.874,35.528-43.839,65.735c6.038,30.21,35.521,49.889,65.737,43.84 c30.209-6.036,49.874-35.528,43.839-65.735c-2.925-14.637-11.373-27.255-23.789-35.535 C1263.616,822.138,1251.881,818.929,1239.984,819.536z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#BDD0FB"
    },
    d: "M1253.214,1053.168c-6.093,0.31-12.237,0.316-18.413,0.008l0,0 c-1.944-0.096-3.887-0.226-5.827-0.385c-9.567-0.788-19.056-2.337-28.321-4.62c-0.126-0.031-0.253-0.062-0.379-0.093 c-0.358-0.09-0.716-0.18-1.073-0.274c-0.697-0.176-1.392-0.362-2.085-0.546c-1.824-0.489-3.051-2.093-3.144-3.883 c-0.022-0.435,0.023-0.882,0.142-1.325c0.608-2.267,2.942-3.603,5.206-3c11.664,3.133,23.744,5.028,35.904,5.634 c60.404,3.035,115.144-25.885,147.809-71.88c18.172-25.581,29.51-56.448,31.191-90.044c0.297-5.891,0.293-11.754-0.006-17.565 c-1.997-39.11-17.257-76.036-43.884-105.467c-30.583-33.809-72.503-53.685-118.033-55.965 c-94.034-4.7-174.293,67.936-179,161.924c-0.291,5.795-0.286,11.584,0.009,17.341c1.276,24.947,7.995,49.339,19.764,71.399 c0.304,0.57,0.465,1.177,0.494,1.782c0.081,1.592-0.742,3.167-2.244,3.966c-2.076,1.099-4.646,0.328-5.751-1.751 c-12.354-23.161-19.413-48.769-20.751-74.96c-0.31-6.043-0.314-12.118-0.011-18.201 c4.941-98.68,89.269-174.931,187.913-169.992c47.801,2.393,91.805,23.26,123.912,58.753 c27.954,30.897,43.973,69.663,46.071,110.72c0.311,6.101,0.315,12.255,0.007,18.438c-2.395,47.803-23.26,91.809-58.751,123.916 C1333.059,1035.057,1294.281,1051.075,1253.214,1053.168z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.3
    }
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#91B3FA"
    },
    d: "M486.541,1251.804c-2.835,0.144-5.541-1.572-6.525-4.39c-1.84-5.258-3.545-10.644-5.067-16.008 c-0.989-3.485,1.033-7.111,4.521-8.104c3.488-1.005,7.114,1.036,8.104,4.521c1.45,5.111,3.075,10.245,4.83,15.263 c1.197,3.417-0.608,7.159-4.027,8.361C487.769,1251.658,487.152,1251.773,486.541,1251.804z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#91B3FA"
    },
    d: "M474.32,1202.827c-3.321,0.169-6.298-2.201-6.812-5.556c-1.459-9.481-2.445-19.145-2.933-28.719 c-0.103-2.016-0.183-4.039-0.245-6.071c-0.105-3.626,2.943-6.521,6.364-6.76c3.623-0.108,6.646,2.742,6.757,6.361 c0.057,1.941,0.133,3.876,0.231,5.802c0.465,9.133,1.407,18.35,2.795,27.391c0.552,3.584-1.905,6.931-5.486,7.485 C474.765,1202.791,474.541,1202.816,474.32,1202.827z M472.294,1134.722c-0.31,0.016-0.628,0.013-0.944-0.016 c-3.611-0.336-6.266-3.531-5.934-7.141c1.066-11.579,2.861-23.195,5.335-34.518c0.772-3.543,4.287-5.775,7.811-5.011 c3.543,0.775,5.783,4.267,5.011,7.81c-2.36,10.804-4.07,21.883-5.089,32.926C478.18,1132.061,475.5,1134.559,472.294,1134.722z  M486.843,1068.16c-0.832,0.042-1.685-0.075-2.518-0.366c-3.417-1.206-5.206-4.958-4-8.375 c3.87-10.945,8.464-21.773,13.664-32.169c1.622-3.246,5.553-4.557,8.805-2.932c3.24,1.619,4.554,5.563,2.935,8.802 c-4.958,9.916-9.341,20.233-13.028,30.674C491.785,1066.374,489.419,1068.029,486.843,1068.16z M517.312,1007.209 c-1.357,0.069-2.745-0.283-3.963-1.088c-3.016-2.009-3.837-6.086-1.828-9.102c6.446-9.684,13.547-19.048,21.113-27.839 c2.366-2.745,6.512-3.046,9.253-0.69c2.748,2.362,3.058,6.504,0.693,9.256c-7.212,8.376-13.988,17.313-20.133,26.545 C521.249,1006.091,519.318,1007.106,517.312,1007.209z M561.742,955.55c-1.895,0.096-3.818-0.627-5.195-2.142 c-2.436-2.68-2.237-6.828,0.442-9.269c8.598-7.811,17.758-15.169,27.228-21.863c2.96-2.102,7.055-1.392,9.147,1.568 c2.092,2.961,1.389,7.058-1.568,9.146c-9.036,6.39-17.774,13.406-25.976,20.863 C564.651,954.914,563.204,955.475,561.742,955.55z M617.356,916.244c-2.454,0.125-4.88-1.144-6.121-3.455 c-1.712-3.192-0.509-7.167,2.682-8.882c10.237-5.488,20.915-10.389,31.732-14.56c3.395-1.296,7.18,0.385,8.485,3.764 c1.304,3.379-0.382,7.18-3.761,8.482c-10.317,3.978-20.493,8.648-30.253,13.88 C619.237,915.949,618.294,916.196,617.356,916.244z M680.876,891.736c-3.072,0.156-5.925-1.873-6.695-4.965 c-0.876-3.517,1.266-7.078,4.782-7.956c11.234-2.799,22.791-4.928,34.353-6.332c3.612-0.377,6.872,2.134,7.305,5.73 c0.437,3.597-2.127,6.865-5.723,7.305c-11.03,1.332-22.052,3.364-32.764,6.033 C681.713,891.655,681.292,891.715,680.876,891.736z M782.584,885.719c-0.378,0.019-0.767,0.007-1.157-0.044 c-9.493-1.191-19.217-1.883-28.906-2.056c-1.468-0.034-2.909-0.051-4.346-0.049c-3.626-0.008-6.56-2.944-6.556-6.57 c-0.002-3.632,2.962-6.67,6.567-6.559c1.534,0.005,3.065,0.017,4.603,0.054c10.122,0.184,20.317,0.909,30.271,2.16 c3.597,0.452,6.145,3.73,5.693,7.327C788.352,883.186,785.704,885.56,782.584,885.719z"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.3
    }
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#91B3FA"
    },
    d: "M765.895,1436.695c-3.578,0.182-6.649-2.549-6.88-6.137c-0.232-3.614,2.512-6.737,6.129-6.966 c10.889-0.696,21.827-2.062,32.511-4.063c3.546-0.63,6.993,1.677,7.659,5.243c0.667,3.565-1.684,6.99-5.243,7.659 c-11.206,2.091-22.673,3.529-34.086,4.259C765.956,1436.692,765.924,1436.694,765.895,1436.695z M732.323,1436.821 c-0.237,0.012-0.471,0.011-0.712-0.002c-11.406-0.638-22.889-1.978-34.13-3.978c-3.568-0.64-5.945-4.041-5.309-7.609 c0.633-3.574,4.06-5.937,7.609-5.316c10.727,1.911,21.684,3.188,32.568,3.8c3.617,0.201,6.386,3.3,6.182,6.917 C738.341,1434.018,735.626,1436.653,732.323,1436.821z M831.752,1424.356c-2.906,0.148-5.66-1.662-6.585-4.567 c-1.097-3.448,0.811-7.138,4.265-8.238c10.402-3.315,20.688-7.284,30.576-11.812c3.308-1.496,7.19-0.058,8.696,3.24 c1.509,3.292,0.059,7.19-3.236,8.699c-10.365,4.744-21.151,8.906-32.055,12.375 C832.858,1424.229,832.302,1424.328,831.752,1424.356z M666.328,1425.028c-0.745,0.038-1.51-0.051-2.266-0.282 c-10.926-3.364-21.753-7.439-32.178-12.111c-3.309-1.481-4.787-5.364-3.307-8.674c1.481-3.296,5.365-4.777,8.67-3.303 c9.942,4.453,20.262,8.335,30.679,11.546c3.462,1.068,5.407,4.742,4.339,8.204 C671.431,1423.112,669.003,1424.891,666.328,1425.028z M892.667,1396.464c-2.32,0.118-4.633-1.002-5.93-3.118 c-1.9-3.092-0.932-7.132,2.154-9.029c9.28-5.696,18.307-12.021,26.832-18.807c2.839-2.262,6.967-1.786,9.223,1.051 c2.256,2.837,1.786,6.967-1.05,9.223c-8.942,7.11-18.405,13.745-28.133,19.721 C894.792,1396.1,893.726,1396.41,892.667,1396.464z M945.116,1354.773c-1.776,0.09-3.579-0.536-4.944-1.879 c-2.581-2.544-2.613-6.7-0.069-9.281c7.662-7.776,14.92-16.083,21.569-24.687c2.218-2.872,6.343-3.397,9.206-1.181 c2.869,2.215,3.396,6.333,1.181,9.199c-6.971,9.024-14.577,17.734-22.606,25.882 C948.255,1354.041,946.697,1354.692,945.116,1354.773z M986.07,1301.712c-1.248,0.064-2.527-0.224-3.681-0.916 c-3.117-1.85-4.14-5.879-2.288-8.995c5.583-9.377,10.633-19.182,15.012-29.139c1.461-3.309,5.333-4.821,8.649-3.36 c3.318,1.46,4.824,5.33,3.363,8.651c-4.595,10.437-9.891,20.723-15.742,30.562 C990.216,1300.474,988.188,1301.604,986.07,1301.712z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#91B3FA"
    },
    d: "M604.878,1397.482c-1.264,0.064-2.559-0.236-3.725-0.94c-4.807-2.906-9.547-5.969-14.096-9.099 c-2.983-2.056-3.74-6.143-1.685-9.129c2.06-2.973,6.14-3.733,9.129-1.684c4.336,2.988,8.86,5.908,13.446,8.683 c3.102,1.875,4.093,5.913,2.217,9.011C608.993,1396.258,606.98,1397.374,604.878,1397.482z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#91B3FA"
    },
    d: "M606.012,1312.542c0.951,1.051,2.464,1.384,3.768,0.827l37.197-15.872 c15.53,10.747,32.886,19.096,51.564,24.47l11.248,38.819c0.394,1.362,1.609,2.323,3.025,2.394l48.449,2.427 c1.416,0.07,2.721-0.765,3.25-2.08l15.069-37.501c19.122-3.481,37.225-10.053,53.751-19.196l35.425,19.509 c1.242,0.683,2.781,0.504,3.832-0.447l35.974-32.543c1.051-0.952,1.384-2.465,0.827-3.768l-15.872-37.197 c10.748-15.53,19.096-32.886,24.47-51.565l38.82-11.247c1.362-0.395,2.323-1.609,2.394-3.025l2.426-48.45 c0.071-1.416-0.764-2.721-2.08-3.249l-37.501-15.07c-3.48-19.122-10.053-37.225-19.196-53.751l19.509-35.427 c0.683-1.241,0.504-2.78-0.446-3.831l-32.543-35.975c-0.951-1.052-2.464-1.383-3.768-0.827l-37.197,15.872 c-15.529-10.749-32.886-19.096-51.564-24.47l-11.248-38.82c-0.395-1.361-1.609-2.323-3.025-2.394l-48.45-2.426 c-1.416-0.071-2.72,0.764-3.249,2.08l-15.069,37.501c-19.122,3.481-37.226,10.053-53.752,19.196l-35.425-19.508 c-1.242-0.685-2.781-0.505-3.832,0.446l-35.974,32.543c-1.051,0.951-1.384,2.464-0.827,3.768l15.871,37.197 c-10.748,15.53-19.096,32.886-24.469,51.565l-38.82,11.247c-1.36,0.394-2.323,1.609-2.393,3.025l-2.427,48.448 c-0.07,1.416,0.764,2.721,2.08,3.25l37.501,15.07c3.481,19.122,10.053,37.224,19.195,53.751l-19.508,35.426 c-0.684,1.242-0.504,2.78,0.446,3.832L606.012,1312.542z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#BDD0FB"
    },
    d: "M750.115,1201.254c-10.572,0.539-20.997-2.311-29.964-8.29 c-11.03-7.356-18.534-18.569-21.131-31.571c-5.365-26.83,12.104-53.028,38.943-58.399 c26.884-5.323,53.041,12.113,58.403,38.949c2.6,13.003-0.02,26.239-7.377,37.265c-7.355,11.033-18.568,18.54-31.573,21.135 C754.986,1200.826,752.544,1201.13,750.115,1201.254z M745.855,1115.2c-1.763,0.09-3.539,0.309-5.321,0.663 c-19.741,3.951-32.59,23.22-28.645,42.962c1.912,9.559,7.43,17.813,15.543,23.219c8.117,5.412,17.849,7.329,27.416,5.431l0,0 c9.563-1.912,17.813-7.434,23.222-15.544c5.412-8.117,7.339-17.852,5.427-27.419 C779.909,1126.554,763.631,1114.294,745.855,1115.2z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#BDD0FB"
    },
    d: "M754.784,1274.37c-4.147,0.211-8.337,0.213-12.57,0.005c-8.405-0.419-16.776-1.693-24.9-3.794 c-0.364-0.097-0.729-0.194-1.093-0.291c-2.817-0.755-4.711-3.231-4.855-5.996c-0.034-0.672,0.036-1.362,0.22-2.045 c0.939-3.5,4.542-5.558,8.038-4.632c7.567,2.034,15.386,3.258,23.241,3.648l0.003,0c0.431,0.023,0.865,0.039,1.293,0.056 c18.598,0.753,36.68-3.159,52.945-11.174c8.828-4.351,17.124-9.92,24.672-16.625c0.062-0.054,0.123-0.109,0.184-0.163 c0.187-0.171,0.375-0.334,0.558-0.504c21.885-19.801,34.754-46.937,36.229-76.413c0.194-3.815,0.19-7.607-0.002-11.37 c-1.293-25.318-11.174-49.223-28.411-68.281c-19.801-21.885-46.937-34.748-76.41-36.223 c-29.456-1.464-57.762,8.616-79.652,28.41c-21.885,19.8-34.754,46.937-36.229,76.413c-0.191,3.75-0.186,7.498,0.004,11.222 c0.826,16.154,5.176,31.941,12.795,46.221c0.469,0.881,0.719,1.818,0.763,2.752c0.125,2.458-1.146,4.891-3.464,6.125 c-3.202,1.697-7.171,0.5-8.881-2.705c-8.523-15.979-13.392-33.646-14.32-51.713c-0.213-4.173-0.218-8.362-0.008-12.557 c1.653-32.982,16.048-63.341,40.537-85.494c24.486-22.147,56.115-33.461,89.107-31.786 c32.978,1.649,63.337,16.041,85.487,40.534c19.287,21.315,30.339,48.061,31.785,76.387c0.214,4.205,0.219,8.452,0.006,12.717 C868.657,1220.943,817.305,1271.184,754.784,1274.37z"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMission);
export default __webpack_public_path__ + "static/media/Mission.b7d4abc3336b617904ca6dc2a6657c92.svg";
export { ForwardRef as ReactComponent };